import React from 'react';
import { Layout } from 'react-admin';
import { CustomAppBar } from './CustomAppBar';
import { CustomMenu } from './CustomMenu';

export const CustomLayout = ({ children, ...props }: any) => (
  <Layout {...props} appBar={CustomAppBar} menu={CustomMenu}>
    {children}
  </Layout>
);





